// src/components/find-investors/investorsData.jsx
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { languagePrefixes } from '../../../i18n';
import Pagination from '../../ui/pagination';
import InvestorsTable from './investorsTable';

const InvestorsData = ({
  investors,
  lng,
  searchKeyword,
  mainOfficeLocation,
  selectedTypes,
  industry,
  currentPage,
  onPageChange,
  totalResults,
  isLoading,
  pageSize = 10,
  previewCap = null,
  pagingLocked = false,
}) => {
  const { i18n } = useTranslation();
  const itemsPerPage = pageSize;
  const totalPages = Math.ceil(totalResults / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const locale = i18n.language || lng || 'en';
  const currentLanguage = locale.split('-')[0];
  const prefix = languagePrefixes[currentLanguage] || '';
  const formatCount = (value) => Number(value || 0).toLocaleString('en-US');
  const shownStr = formatCount(previewCap);
  const totalStr = formatCount(totalResults);

  return (
    <>
      {/* mobile/tablet: one column; lg+: 1fr | auto */}
      <div className="mt-4 grid items-center gap-3 sm:pr-6 grid-cols-1 lg:[grid-template-columns:minmax(0,1fr)_auto]">
        <div className="min-w-0">
          <Pagination
            className="w-full"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            locked={pagingLocked}
          />
        </div>

        {!!previewCap && (
          <div className="justify-self-start lg:justify-self-end w-full lg:w-auto lg:max-w-[680px] md:max-w-none">
            <span
              className="
                inline-block bg-stone-100 rounded-md px-3 py-1 text-sm text-stone-700
                whitespace-normal break-words
                lg:whitespace-nowrap lg:overflow-hidden lg:text-ellipsis
              "
            >
              <Trans
                i18nKey="pageFindInvestors.previewBadgeNoPercent"
                values={{
                  shown: shownStr,
                  total: totalStr,
                }}
                components={{
                  signupLink: (
                    <Link
                      to={`${prefix}/signup`}
                      className="font-medium underline underline-offset-2 hover:text-stone-900"
                    />
                  ),
                }}
              />
            </span>
          </div>
        )}
      </div>

      <div className="overflow-x-auto my-6">
        <div className={previewCap ? 'relative' : ''}>
          {previewCap && (
            <div className="pointer-events-none absolute inset-0 z-10 rounded-md bg-white/10" />
          )}
          <InvestorsTable
            currentInvestors={investors}
            lng={lng}
            startIndex={startIndex}
            isLoading={isLoading}
            pageSize={itemsPerPage}
          />
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        locked={pagingLocked}
      />
    </>
  );
};

export default InvestorsData;
